<template>
  
  <form action="/" class="form" method="post" @submit.prevent="submitForm">
    <h2 class="text-[20px] leading-[28px] font-medium m-0">{{ in18['page_contact_information'] }}</h2>
    <div class="section__text">
      {{ in18['page_edit_profile_permission_msg'] }}
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-[16px]">
      <div class="flex flex-col gap-1 relative">
          <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.name ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="user_name">
              {{ in18['attribute_user_name'] }}
          </label>
          <input
              id="user_name"
              v-model="user.name"
              :class="[errors['user.name'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.name && 'pt-[30px]']"
              :disabled="inProgress"
              class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
              name="user_name"
              type="text"
              @input="clearValidationError('user.name')"
          >
          <span v-if="errors['user.name']?.length" class="!text-[12px] text-[#eb2635]">*{{ errors['user.name']?.[0] }}</span>
      </div>
      <div class="flex flex-col gap-1 relative">
          <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.surname ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="user_surname">
              {{ in18['attribute_user_surname'] }}
          </label>
          <input
              id="user_surname"
              v-model="user.surname"
              :class="[errors['user.surname'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.surname && 'pt-[30px]']"
              :disabled="inProgress"
              class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
              name="user_surname"
              type="text"
              @input="clearValidationError('user.surname')"
          >
          <span v-if="errors['user.surname']?.length" class="!text-[12px] text-[#eb2635]">*{{ errors['user.surname']?.[0] }}</span>
      </div>
      <div class="flex flex-col gap-1 relative">
          <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.email ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="user_email">
              {{ in18['attribute_user_email'] }}
          </label>
          <input
              id="user_email"
              v-model="user.email"
              :class="[errors['user.email'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.email && 'pt-[30px]']"
              :disabled="inProgress"
              class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
              name="user_email"
              type="text"
              @input="clearValidationError('user.email')"
          >
          <span v-if="errors['user.email']?.length" class="!text-[12px] text-[#eb2635]">*{{ errors['user.email']?.[0] }}</span>
      </div>
      <div class="flex flex-col gap-1 relative overflow-hidden">
        <label class=" leading-[14px] font-light absolute left-[17px] transition-all pointer-events-none" :class="[user.phone.number ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="mobile_phone_number">
          {{ in18['attribute_user_phone'] }}
        </label>

        <input
            id="mobile_phone_number"
            v-model="user.phone.number"
            :class="[errors['user.phone.number'] || errors['user.phone.countryCallingCode'] ? 'border-[#eb2635] ' : 'focus-within:border-lime-green border-light-gray/25', user.phone.number ? 'pl-[100px] pt-[30px]' : 'pl-[16px]' ]"
            :disabled="inProgress"
            class="h-[52px] text-[16px] p-[16px]   font-light leading-[20px] text-charcoal border rounded-[8px] outline-none focus-within:border-lime-green transition-all"
            name="mobile_phone_number"
            type="number"
            @input="clearValidationError('user.phone.number')"
        >
        <div :class="[user.phone.number ? 'top-[23px] left-[16px] opacity-100': 'top-[-4px] left-[-60px] opacity-0 pointer-events-none']" class="absolute  text-[16px] font-thin leading-[20px] pr-2 border-r border-l-medium-gray transition-all">

            <span class="prefix">+</span>

            <select v-bind:preventFocusShift="true" class="outline-none bg-opacity-0 w-[60px]" v-model="user.phone.countryCallingCode" @update="clearValidationError('user.phone.countryCallingCode')" name="user_phone_country" id="">
              <option v-for="c in getEUPhoneCountries()" :value="c.countryCallingCode" class="text-[14px]">
                  {{ c.countryCallingCode  }}
              </option>
            </select>

        </div>
        
        <span v-if="phoneErrors?.length" class=" text-[12px] text-[#eb2635]">*{{ phoneErrors?.[0]}}</span>
      </div>
    </div>
    <div v-if="user.type === 'b2b' || user.type === 'b2g'" class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-[16px]">
      <div class="flex flex-col gap-1 relative">
            <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.company.name ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="company_name">
                {{ in18['attribute_company_name'] }}
            </label>
            <input
                id="company_name"
                v-model="user.company.name"
                :class="[errors['user.company.name'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.company.name && 'pt-[30px]' ]"
                disabled
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="company_name"
                type="text"
                @input="clearValidationError('user.company.name')"
            >
            <span v-if="errors['user.company.name']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['user.company.name']?.[0]}}</span>
      </div>
      <div class="flex flex-col gap-1 relative">
            <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.company.reg_num ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="company_reg_num">
                {{ in18['attribute_company_reg_number'] }}
            </label>
            <input
                id="company_reg_num"
                v-model="user.company.reg_num"
                :class="[errors['company.reg_num'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.company.reg_num && 'pt-[30px]' ]"
                disabled
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="company_reg_num"
                type="text"
                @input="clearValidationError('company.reg_num')"
            >
            <span v-if="errors['company.reg_num']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['company.reg_num']?.[0]}}</span>
      </div>
      <div class="flex flex-col gap-1 relative">
            <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.company.vat_num ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="company_vat_num">
                {{ in18['attribute_company_tax_number'] }}
            </label>
            <input
                id="company_vat_num"
                v-model="user.company.vat_num"
                :class="[errors['company.vat_num'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.company.vat_num && 'pt-[30px]' ]"
                disabled
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="company_vat_num"
                type="text"
                @input="clearValidationError('company.vat_num')"
            >
            <span v-if="errors['company.vat_num']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['company.vat_num']?.[0]}}</span>
      </div>
    </div>

    <div class="mt-[24px] flex flex-col gap-[16px]">
      <h2 class="text-[20px] leading-[28px] font-medium m-0">{{ in18['page_password_change'] }}</h2>
      <div v-if="showChangePasswordForm" class="grid grid-cols-1 sm:grid-cols-2 gap-[16px]">
        <div class="flex flex-col gap-1 relative">
            <div class="relative w-full">
              <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.new_password ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="new_password">
                  {{ in18['attribute_password_new_password'] }}
              </label>
              <input
                  id="new_password"
                  v-model="user.new_password"
                  :class="[errors['user.new_password'] ? 'border-[#eb2635]' : ' focus-within:border-lime-green border-light-gray/25', user.new_password && 'pt-[30px]' ]"
                  :disabled="inProgress"
                  class="w-full h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                  name="new_password"
                  type="password"
                  @input="clearValidationError('user.new_password')"
                  autocomplete="new-password"
              >
              <button class="form-control-showhide" data-target="#user_password" type="button">
                {{ in18['attribute_show_hide'] }}
              </button>
            </div>
            <span v-if="errors['user.new_password']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['user.new_password']?.[0]}}</span>
        </div>

        <div class="flex flex-col gap-1 ">
            <div class="relative w-full">
              <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none" :class="[user.new_password_confirmation ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="new_password_confirmation">
                  {{ in18['attribute_password_confirm_password'] }}
              </label>
              <input
                  id="new_password_confirmation"
                  v-model="user.new_password_confirmation"
                  :class="[errors['user.new_password_confirmation'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.new_password_confirmation && 'pt-[30px]' ]"
                  :disabled="inProgress"
                  class="w-full h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                  name="new_password_confirmation"
                  type="password"
                  @input="clearValidationError('new_password_confirmation')"
                  autocomplete="new-password"
              >
              <button class="form-control-showhide" data-target="#user_password" type="button">
                {{ in18['attribute_show_hide'] }}
              </button>
            </div>
            <span v-if="errors['user.new_password_confirmation']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['user.new_password_confirmation']?.[0]}}</span>
        </div>
      </div>
      <button @click.prevent="togglePasswordFields" :title="togglePasswordText" class="text-[16px] leading-[20px] font-light text-lime-green" :class="[in18['page_change_password'] === togglePasswordText ? 'w-max px-[16px] py-[8px] border border-lime-green rounded-[8px] hover:bg-lime-green hover:text-white transition-all' : 'no-underline']">
        {{ togglePasswordText }}
      </button>
    </div>

    <google-recaptcha-v3
        id="profile_action"
        ref="recaptcha"
        v-model="gRecaptchaResponse"
        :site-key="captcha_site_key"
        action="profile_action"
        corner
      ></google-recaptcha-v3>

    <div class="mt-[32px] flex gap-[16px]">
      <button :disabled="inProgress" :title="in18['page_save']" class="block px-[28px] py-[14px] bg-lime-green text-white hover:bg-lime-green-hover rounded-[8px] text-[16px] font-medium transition-all" type="submit">
        {{ in18['page_save'] }}
      </button>
      <a role="button" href="/profile" :title="in18['page_cancel']" :disabled="inProgress" class="block px-[28px] py-[14px] text-charcoal text-[16px] border border-charcoal rounded-[8px] hover:text-white hover:bg-charcoal hover:border-charcoal transition-all" >
        {{ in18['page_cancel'] }}
      </a>
    </div>
  </form>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import axios from 'axios';
import { getEUPhoneCountries } from '../../helpers/phone-countries';

const props = defineProps({
  user: Object,
  banks: Object,
  in18: Object,
  captcha_site_key: String,
});

const inProgress = ref(false);
const errors = ref({});
const showChangePasswordForm = ref(false);
const recaptchaLoaded = ref(false);
const gRecaptchaResponse = ref(null);

const user = reactive(JSON.parse(JSON.stringify(props.user)));

const in18 = props.in18;
const captcha_site_key = props.captcha_site_key;

const recaptcha = ref(null);

const togglePasswordText = computed(() =>
  showChangePasswordForm.value
    ? in18['page_change_password_off']
    : in18['page_change_password']
);

const phoneErrors = computed(() => {
  let errorsArray = [];
  if (errors.value['user.phone.number']) {
    errorsArray = errorsArray.concat(errors.value['user.phone.number']);
  }
  if (errors.value['user.phone.countryCallingCode']) {
    errorsArray = errorsArray.concat(errors.value['user.phone.countryCallingCode']);
  }
  return errorsArray;
});

function initRecaptcha() {
  if (!recaptchaLoaded.value) {
    recaptcha.value.init();
    recaptchaLoaded.value = true;
  }
}

function clearValidationError(fieldName) {
  if (errors.value[fieldName]) {
    errors.value[fieldName] = null;
  }
}

function togglePasswordFields() {
  showChangePasswordForm.value = !showChangePasswordForm.value;
}

function submitForm() {
  if (inProgress.value) {
    return;
  }

  inProgress.value = true;

  const data = {
    user: user,
    gRecaptchaResponse: gRecaptchaResponse.value,
  };

  axios
    .post('/api/user/update', data)
    .then((response) => {
      errors.value = {};
      window.toastr.success(response.data.message);
      Object.assign(user, response.data.user);
    })
    .catch((error) => {
      window.toastr.error(error.response.data.message);
      errors.value = error.response.data.errors;
    })
    .finally(() => {
      inProgress.value = false;
      recaptcha.value.execute();
      window.scrollToErrorMessage();
    });
}

onMounted(() => {
  initRecaptcha();
});
</script>

<style scoped>
/* Add your component-specific styles here */
</style>
